module.exports = __webpack_public_path__ + "img/oliver-d.fe1a59df.png";